import script from "./page-error.vue?vue&type=script&lang=ts&setup=true"
export * from "./page-error.vue?vue&type=script&lang=ts&setup=true"

import "./page-error.vue?vue&type=style&index=0&id=3aa73d28&lang=scss&scoped=true"

import exportComponent from "/Users/zhangjun/Desktop/project/envo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa73d28"]])

export default __exports__